import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"
import { message } from "antd";
import { Upload } from "antd";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}




// Debounce function outside component
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// In your utils.js file (or wherever beforeUploadValidation is defined)
export const beforeUploadValidation = (file, fileType, maxSizeMB = 5, expectedWidth, expectedHeight) => {
  // Size validation
  const isLtSize = file.size / 1024 / 1024 < maxSizeMB;
  if (!isLtSize) {
    message.error(`${fileType} must be smaller than ${maxSizeMB}MB!`);
    return Upload.LIST_IGNORE;
  }

  // Image dimension check
  if (file.type.startsWith('image/')) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          if (expectedWidth && expectedHeight && 
              (img.width !== expectedWidth || img.height !== expectedHeight)) {
            message.warning(
              `${fileType} recommended size is ${expectedWidth}x${expectedHeight}px. ` +
              `Your image is ${img.width}x${img.height}px. It may not display correctly.`,
              5
            );
          }
          resolve(true);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  return true;
};